import { useMediaQuery } from '@hotmart/space-lib/dist/hooks'
import { useTrackEvents, useUserProfile } from 'src/context/userProfileContext'
import { UserAvatar } from 'src/components/userAvatar'
import { ModerationTag } from 'src/components/moderationTag'
import { ManagerRoles } from 'src/hook/useUser/constants'
import { DateUtils } from 'src/utils/date'
import { ComponentName } from 'src/utils/datahubDefaultEvent'
import { ScreenSizes } from 'src/styles'
import { TrendingPostTag } from 'src/components'
import { FeedCardHeaderActions } from '../feedCardHeaderActions'
import { FeedCardHeaderProps } from './feedCardHeader.types'
import { MEDALS } from './feedCardHeader.constants'
import { AuthorName, ModerationWrapper, PostInfo } from './feedCardHeader.styles'

const FeedCardHeader = ({ post, isScheduledPost }: FeedCardHeaderProps) => {
  const { loggedUserUcode, onOpen: onOpenUserProfile } = useUserProfile()
  const { sendOpenProfileEvent } = useTrackEvents({ loggedUserUcode })
  const isMobile = useMediaQuery(`(max-width: ${ScreenSizes.md})`)

  const medal = post.authorFeaturedMemberRank ? MEDALS[post.authorFeaturedMemberRank] : undefined
  const isModerator = post.authorMemberType === ManagerRoles.MODERATOR
  const postDate = DateUtils.compareDates(post.pubDate)

  const handleOpenUserProfile = (event: React.MouseEvent | React.KeyboardEvent) => {
    onOpenUserProfile(event, post.authorUcode)
    sendOpenProfileEvent({
      componentName: ComponentName.POST_FEED,
      userUcode: post.authorUcode
    })
  }

  return (
    <header className="_pl-4 _pt-4 _pr-4 _pb-5">
      <div className="_d-flex _align-items-center _justify-content-between">
        <div className="_d-flex _align-items-center _flex-1">
          <div
            className="_mr-3 _cursor-pointer"
            role="button"
            tabIndex={0}
            onClick={handleOpenUserProfile}
            onKeyDown={handleOpenUserProfile}
          >
            <UserAvatar src={post?.authorImageFinalUrl} alt={post.authorName} small />
          </div>

          <div className="_d-flex _flex-column _flex-1">
            <div className="_d-flex _align-items-center _mb-1">
              <AuthorName
                className="_text-2 _text-gray-900 _font-weight-bold _line-height _mr-1 _cursor-pointer"
                role="button"
                tabIndex={0}
                onClick={handleOpenUserProfile}
                onKeyDown={handleOpenUserProfile}
              >
                {post.authorName}
              </AuthorName>

              {medal && <img src={medal} className="_mr-1" alt={post.authorName} />}
            </div>

            <PostInfo className="_d-flex _align-items-center">
              {isModerator && (
                <ModerationWrapper className="_pr-3">
                  <ModerationTag />
                </ModerationWrapper>
              )}

              <span className="_text-1">{postDate}</span>
              {!isMobile && post?.trending && <TrendingPostTag />}
            </PostInfo>
          </div>
        </div>

        <FeedCardHeaderActions post={post} isScheduledPost={isScheduledPost} />
      </div>

      {isMobile && post?.trending && <TrendingPostTag className="_mt-3" />}
    </header>
  )
}

export default FeedCardHeader
